<template>
  <div class="text-center">
    <div class="title title--sm">
      <h1>Консультация по программному обеспечению</h1>
      <p>Менеджер свяжется с вами, чтобы ответить на все вопросы и подготовить коммерческое предложение.</p>
    </div>
      <div class="container">
        <div class="block-center">
          <Feedback mode="solution"/>
          <div class="contacts__sub mt-60">Контакты</div>
          <ul class="contacts__data">
            <li>
              <a href="mailto:sales@giveandgo.ru">sales@giveandgo.ru</a>
            </li>
            <li>
              <a href="tel:+79062106621">+7 906 21 066 21</a><span> (Whatsapp, Telegram, Viber)</span>
            </li>
          </ul>
        </div>
      </div>
  </div>
</template>
<script>
const name = 'SolutionRequest'
import Feedback from '@/components/Feedback.vue'


export default {
  name,
  components: {
    Feedback
  }
}

</script>
